/**
 * Calculate percentage of cancellations orders / jobs from total orders.
 * Takes total of "done" orders and "cancelled" orders
 * and returns the percentage of cancellations.
 */
export function calcCancelledOrdersPercentage(
	done: number,
	cancelled: number,
): number {
	if (done + cancelled === 0) {
		return 0;
	}

	return Math.round((cancelled / (done + cancelled)) * 100);
}
